module.exports = __webpack_public_path__ + "static/media/vendor.f5457150.svg";